import React from 'react';

const EmptyValue = () => <i>&lt;Empty Value&gt;</i>;

export default EmptyValue;
